export default {
  user: null,
  userLicense: null,
  selectedLicenseCategory: null,
  inputForm: {},
  pictureSrc: null,
  registeredLicense: null
};
